/**
 * Selects which widgets to preview for a checkout experience, mirroring the
 * node badge's count logic (buildWidgetInfos in get-checkout-tree-flow-steps):
 * prefer the widgets explicitly assigned to the experience, and when none are
 * assigned fall back to the team's default-enabled widgets. Without the
 * fallback the hover would show "No widget preview available" for an experience
 * whose badge count comes entirely from default-enabled widgets, since
 * assignedExperienceIds only reflects explicit assignment.
 */
export function selectWidgetsForExperiencePreview<
  T extends { assignedExperienceIds: string[]; defaultEnabled?: boolean },
>(allWidgets: T[], checkoutExperienceId: string): T[] {
  const assigned = allWidgets.filter((widget) =>
    widget.assignedExperienceIds.includes(checkoutExperienceId),
  );
  if (assigned.length > 0) {
    return assigned;
  }
  return allWidgets.filter(
    (widget) => "defaultEnabled" in widget && widget.defaultEnabled === true,
  );
}
